import { Box } from '@mui/material';
import { RenderTable } from '../../../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  apiData: any;
  top20?: any;
}
const TController = ({ apiData, top20 }: IProps) => {
  return (
    <Box>
      <RenderTable>
        <>
          <THead top20={top20} />
          <TBody apiData={apiData} top20={top20} />
          <TFoot apiData={apiData} />
        </>
      </RenderTable>
    </Box>
  );
};

export default TController;
